import React,{useState} from 'react';
import{HashRouter as Router, Routes,Route, Link} from 'react-router-dom'
import About from "./About"
import GetStarted from "./GetStarted"
import Thrustinfo from "./Thrustinfo"
import Draginfo from "./Draginfo"
import Liftinfo from "./Liftinfo"
import Animation from "./Animation"
import Home from "./Home"
import "./Navbar.css"

const Navbar=()=>{
	const[show,setShow]=useState(false)
	return(
		<div>
		
			<div className='hamburgericon' onClick={()=>setShow(!show)}>
				<div className="bar"></div>
				<div className="bar"></div>
				<div className="bar"></div>
			</div>
	
		<Router>
			<div className="desknav">
			
				<ul>

		                   <li><Link to="/" className="links">Home</Link></li>
		                   <li><Link to="/getstarted" className="links">Get Started</Link></li>
		                   <li><Link to="/about" className="links">About</Link></li>
		                   {/*<li><Link to="/about" className="links">Services</Link></li>
		                   <li><Link to="/about" className="links">Contact</Link></li>
*/}		        </ul>
	        </div>
				

		
	        <div className="mobnav">
	        {
		        show?<ul>

		                   <li><Link to="/" className="links">Home</Link></li>
		                   <li><Link to="/getstarted" className="links">Get Started</Link></li>
		                   <li><Link to="/about" className="links">About</Link></li>
		                   
		        </ul>:null
		    }
	        </div>
	        <Routes>
          <Route path="/about" exact element={<About/>} />
          <Route path="/getstarted" exact element={<GetStarted/>} />
          <Route path="/" exact element={<Home/>} />
          <Route path="/liftinfo" exact element={<Liftinfo/>} />
          <Route path="/draginfo" exact element={<Draginfo/>} />
          <Route path="/thrustinfo" exact element={<Thrustinfo/>} />
          <Route path="/animation" exact element={<Animation/>} />
          
          </Routes>
          </Router>
        </div>

        
		);
}
export default Navbar;


// import React from "react";
// import{HashRouter as Router, Routes,Route, Link} from 'react-router-dom';
// import Home from "./Home";
// import About from "./About"
// import GetStarted from "./GetStarted";
// import "./Navbar.css";
// import logo from "../imgs/AEROneerLogo.png";

// const Navbar=()=>{
// 	return(
// 		<div className="Navbar">
	
// 			<Router>
// 		<nav>
// 			<ul className="nav__links">
// 				<li><Link to="/" className="links">Home</Link></li>
// 				<li><Link to="/getstarted" className="links">Get Started</Link></li>
// 				<li><Link to="/about" className="links">About</Link></li>
// 				{/*<li><a href="#">Contact us</a></li>*/}


// 			</ul>
// 		</nav>
// 			<Routes>
// 					<Route exact path="/getstarted" exact element={<GetStarted/>} />
// 					<Route exact path="/about" exact element={<About/>} />
// 					<Route exact path="/" exact element={<Home/>} />
// 			</Routes>

// 	        </Router>

// 		</div>
// 		);
// }
// export default Navbar;